import { render, staticRenderFns } from "./SoftOneDocumentTypesManagementModal.vue?vue&type=template&id=202c82f6"
import script from "./SoftOneDocumentTypesManagementModal.vue?vue&type=script&lang=js"
export * from "./SoftOneDocumentTypesManagementModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports